export const ROUTE_ENDPOINTS = {
    LOGIN: '/login',
    HOME: '/home',
};